import Keycloak from 'keycloak-js'

export const allRoles = ['QiAdmin', 'Administrator', 'Project Manager', 'Broker', 'Marketer']
const scopesList = 'email profile'

type AuthObject = {
    token: string
    idToken: string
    refreshToken: string
}

export default defineNuxtPlugin(async () => {
    const authCookie = useCookie('authCookie')
    const auth = ref<Keycloak | null>(null)

    const config = useRuntimeConfig()
    const realm = `${config.public.authRealm}`
    const url = `${config.public.authApiUrl}`

    const authSettings = {
        realm,
        url,
        clientId: 'qi-frontend',
        'public-client': true,
        'confidential-port': 0
    }

    const keycloak: Keycloak = new Keycloak(authSettings)

    keycloak.onReady = (authenticated) => {
        if (!authenticated) {
            auth.value = null
        }
    }

    keycloak.onTokenExpired = async () => {
        await keycloak.updateToken(300)
    }

    keycloak.onAuthLogout =
        keycloak.onAuthError =
        keycloak.onAuthRefreshError =
            () => {
                auth.value = null
            }

    keycloak.onAuthSuccess = () => {
        console.log('SUCCESS')
        auth.value = keycloak
        const { token, idToken, refreshToken } = keycloak

        authCookie.value = JSON.stringify({
            token,
            idToken,
            refreshToken
        })
    }

    let token = null
    let idToken = null
    let refreshToken = null

    const authObjectCookie = authCookie.value

    if (authObjectCookie) {
        const authObject: AuthObject = authObjectCookie as any as AuthObject
        token = authObject?.token
        idToken = authObject?.idToken
        refreshToken = authObject?.refreshToken
    }

    await keycloak.init({
        flow: 'standard',
        redirectUri: location.href,
        scope: scopesList,
        checkLoginIframe: true,
        refreshToken,
        idToken,
        token
    })

    if (process.env.NODE_ENV !== 'production') {
        console.log('Keycloak initialized', keycloak)
    }

    return {
        provide: {
            auth: keycloak
        }
    }
})
